import * as objectTypes from "../../../../constants/objectTypes";
import * as optionHelper from "../../../../helpers/optionHelper";
import * as propertyConstants from "../../../../constants/propertyConstants";
import * as translationHelper from "../../../../helpers/translationHelper";

import { Database, generateDatabaseData, generateDatabaseHeadings } from "../../../../types/database";
import React, { Component } from "react";

import { Company } from "../../../../types/company";
import { ModalProperties } from "../../../../types/modalProperties";
import { TableContainer } from "../../../Table";
import { TableHeading } from "../../../../types/tableHeading";

type Props = {
    tableConstant: string;
    objectType: objectTypes.ObjectType;
    privileges: any;
    dataPrivileges: any;
    loading: boolean;
    companyList: Array<Company>;
    allList: Array<Database>;
    activeList: Array<Database>;
    columnOrder: Array<propertyConstants.Property>;
    columnVisibility: Record<propertyConstants.Property, boolean>;
    columnWidth: Record<propertyConstants.Property, number>;
    offset: number;
    page: number;
    rowCount: number;
    rowCountCustom: boolean;
    search: string | null;
    searchParams: Record<propertyConstants.Property, string>;
    showFilterRow: boolean;
    showGlobalSearch: boolean;
    sortingAsc: boolean;
    sortingCriterion: propertyConstants.Property | null;
    totalCount: number | null;
};

export class MonitoringDatabaseTable extends Component<Props> {
    generateTableHeadings = (): Array<TableHeading> => {
        const requiredList: Array<propertyConstants.Property> = [
            propertyConstants.PROPERTY_COMPANY_ID,
            propertyConstants.PROPERTY_NAME
        ];
        const alwaysVisibleList: Array<propertyConstants.Property> = [propertyConstants.PROPERTY_NAME];

        let visibleList: Array<propertyConstants.Property> = [
            propertyConstants.PROPERTY_NAME,
            propertyConstants.PROPERTY_COMPANY_ID,
            propertyConstants.PROPERTY_MORE_INFO,
            propertyConstants.PROPERTY_LENGTH
        ];

        const orderList = optionHelper.handleTableHeadingOrder(visibleList, this.props.columnOrder);
        visibleList = optionHelper.handleTableHeadingVisibility(visibleList, this.props.columnVisibility);

        return generateDatabaseHeadings(
            this.props.objectType,
            null,
            this.props.companyList,
            orderList,
            visibleList,
            [],
            requiredList,
            alwaysVisibleList,
            this.props.columnWidth
        );
    };

    render(): JSX.Element {
        const modalProperties: ModalProperties = {};
        return (
            <div className="height-100">
                <TableContainer
                    className={"table-with-filter"}
                    tableConstant={this.props.tableConstant}
                    objectType={this.props.objectType}
                    dataPrivileges={this.props.dataPrivileges}
                    title={translationHelper.getTitleSectionTranslation(this.props.objectType)}
                    titleClassName={"title"}
                    loading={this.props.loading}
                    headings={this.generateTableHeadings()}
                    data={generateDatabaseData(this.props.allList)}
                    activeData={this.props.activeList}
                    offset={this.props.offset}
                    page={this.props.page}
                    rowCount={this.props.rowCount}
                    rowCountCustom={this.props.rowCountCustom}
                    search={this.props.search}
                    searchParams={this.props.searchParams}
                    showFilterRow={this.props.showFilterRow}
                    showGlobalSearch={this.props.showGlobalSearch}
                    sortingAsc={this.props.sortingAsc}
                    sortingCriterion={this.props.sortingCriterion}
                    totalCount={this.props.totalCount}
                    modalProperties={modalProperties}
                />
            </div>
        );
    }
}
